import { VIF_CONSTANTS, DEFAULT_PRIMARY_COLOR } from 'common/authoring_workflow/constants';
import { type Vif } from 'common/visualizations/vif';

export const defaultScatterChartVif: Vif = {
  format: {
    type: 'visualization_interchange_format',
    version: VIF_CONSTANTS.LATEST_VERSION,
  },
  configuration: {
    viewSourceDataLink: true,
  },
  description: '',
  series: [
    {
      color: {
        primary: DEFAULT_PRIMARY_COLOR,
      },
      dataSource: {
        datasetUid: null,
        dimension: { columnName: '' },
        domain: null,
        measure: {
          columnName: null,
          aggregationFunction: null,
        },
        type: 'socrata.soql',
        filters: [],
      },
      label: null,
      type: 'scatterChart',
    },
    {
      color: {
        primary: DEFAULT_PRIMARY_COLOR,
      },
      dataSource: {
        datasetUid: null,
        dimension: { columnName: '' },
        domain: null,
        measure: {
          columnName: null,
          aggregationFunction: null,
        },
        type: 'socrata.soql',
        filters: [],
      },
      label: null,
      type: 'scatterChart',
    },
    {
      color: {
        primary: DEFAULT_PRIMARY_COLOR,
      },
      dataSource: {
        datasetUid: null,
        dimension: { columnName: '' },
        domain: null,
        measure: {
          columnName: null,
          aggregationFunction: null,
        },
        type: 'socrata.soql',
        filters: [],
      },
      label: null,
      type: 'scatterChart',
    },
    {
      color: {
        primary: DEFAULT_PRIMARY_COLOR,
      },
      dataSource: {
        datasetUid: null,
        dimension: { columnName: '' },
        domain: null,
        measure: {
          columnName: null,
          aggregationFunction: null,
        },
        type: 'socrata.soql',
        filters: [],
      },
      label: null,
      type: 'scatterChart',
    },
  ],
  title: '',
};
